import * as React from 'react';

interface PlusIconProps {
    stroke?: string;
}

const PlusIcon: React.FC<PlusIconProps> = ({ stroke = 'var(--primary-color)' }: PlusIconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
            <path stroke={stroke} strokeWidth="2" d="M0 6h12M6 0v12" />
        </svg>
    );
};

export default React.memo(PlusIcon);
